import { onBeforeUnmount } from 'vue'

const SESSION_MS = 30 * 60 * 1000
const KEY_EXPIRE = 'sessionExpireAt'
const KEY_WARNED = 'sessionWarned'

export function initSessionTimer() {
    sessionStorage.setItem(KEY_EXPIRE, Date.now() + SESSION_MS)
    sessionStorage.removeItem(KEY_WARNED)
}

export function extendSessionTimer() {
    sessionStorage.setItem(KEY_EXPIRE, Date.now() + SESSION_MS)
    sessionStorage.removeItem(KEY_WARNED)
}

export function setSessionTimerByRemainingSeconds(remainingSeconds) {
    const sec = Number(remainingSeconds)
    if (!Number.isFinite(sec)) return false
    const safeSec = Math.max(0, Math.floor(sec))
    sessionStorage.setItem(KEY_EXPIRE, Date.now() + safeSec * 1000)
    sessionStorage.removeItem(KEY_WARNED)
    return true
}

export function clearSessionTimer() {
    sessionStorage.removeItem(KEY_EXPIRE)
    sessionStorage.removeItem(KEY_WARNED)
}

export function useSessionTimer({ onExpire, warningSec = 55, isEnabled = () => true }) {
    let intervalId = null

    const updateUI = (remainMs) => {
        const sec = Math.max(0, Math.floor(remainMs / 1000))
        const min = Math.floor(sec / 60)
        const s = sec % 60
        const timeStr = `${min}:${String(s).padStart(2, '0')}`

        const timerEl = document.getElementById('session-timer')
        if (timerEl) timerEl.textContent = timeStr

        const infoEl = document.getElementById('session_pop_info')
        if (infoEl) infoEl.textContent = `${timeStr} 후 자동 로그아웃됩니다.`

        // 경과 시간 = 전체 세션 시간 - 남은 시간 ("mm:ss 동안 서비스를 이용하지 않아")
        const elapsedSec = Math.max(0, Math.floor((SESSION_MS - Math.max(0, remainMs)) / 1000))
        const eMin = Math.floor(elapsedSec / 60)
        const eSec = elapsedSec % 60
        const elapsedStr = `${eMin}:${String(eSec).padStart(2, '0')}`
        const infoTime = document.getElementById('session_info_time')
        if (infoTime) infoTime.textContent = elapsedStr
    }

    const showPopup = (remainMs) => {
        if (sessionStorage.getItem(KEY_WARNED)) return
        sessionStorage.setItem(KEY_WARNED, 'Y')

        document.querySelector('.pop_logout')?.classList.add('on')
    }

    const tick = () => {
        if (!isEnabled()) return

        const expireAt = Number(sessionStorage.getItem(KEY_EXPIRE))
        if (!expireAt) return

        const remain = expireAt - Date.now()
        updateUI(remain)

        if (remain <= 0) {
            stop()
            onExpire?.()
            return
        }

        // 55초 남았을 때 팝업
        if (remain <= warningSec * 1000) {
            showPopup(remain)
        }
    }

    const start = () => {
        stop()
        intervalId = setInterval(tick, 1000)
        tick()
    }

    const stop = () => {
        if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
        }
    }

    onBeforeUnmount(stop)

    return { start, stop }
}
